export default {
    kinds: {
        sleep: 'Sen',
        nap: 'Drzemka',
        workout: 'Trening',
        meal: 'Posiłek',
        task: 'Zadanie',
        project: 'Projekt',
        note: 'Notatka',
        report: 'Wpis dnia',
        activity: 'Czynność',
        event: 'Wydarzenie',
        repeat: 'Zadanie cykliczne',
        payment: 'Płatność',
        personDate: 'Ważna data',
        care: 'Obsługa',
    },
    filters: {
        events: 'Wydarzenia',
        meals: 'Posiłki',
        sleep: 'Sen',
        tasks: 'Zadania',
        workouts: 'Treningi',
        reports: 'Wpisy dnia',
        activities: 'Czynności',
        payments: 'Płatności',
    },
    weekdays: {
        short: { mon: 'pn', tue: 'wt', wed: 'śr', thu: 'cz', fri: 'pt', sat: 'sb', sun: 'nd' },
        long: { mon: 'poniedziałek', tue: 'wtorek', wed: 'środa', thu: 'czwartek', fri: 'piątek', sat: 'sobota', sun: 'niedziela' },
    },
    repeat: {
        none: 'Nie',
        daily: 'Codziennie',
        weekdays: 'W dni robocze',
        weekly: 'Co tydzień',
        monthly: 'Co miesiąc',
    },
    repeatRule: {
        daily: 'codziennie',
        weekdays: 'w dni robocze',
        weekly: 'co tydzień',
        monthly: 'co miesiąc',
        repeats: 'powtarza się',
        every: {
            daily: 'co {n} dni',
            weekly: 'co {n} tydzień | co {n} tygodnie | co {n} tygodni',
            monthly: 'co {n} miesiąc | co {n} miesiące | co {n} miesięcy',
        },
    },
    reminder: {
        none: 'Bez',
        onTime: 'O czasie',
        minutes: '{n} min przed',
        hour: 'Godzinę przed',
        day: 'Dzień przed',
    },
    relation: {
        today: 'dzisiaj',
        yesterday: 'wczoraj',
        tomorrow: 'jutro',
    },
    flash: {
        settingsFailed: 'Nie udało się zapisać ustawień.',
        taskFailed: 'Nie udało się zapisać zmiany zadania.',
        mealFailed: 'Nie udało się zmienić stanu posiłku.',
        workoutFailed: 'Nie udało się zmienić stanu treningu.',
        rescheduleFailed: 'Nie udało się przestawić zadań.',
        moveFailed: 'Nie udało się przenieść wpisu.',
        resizeFailed: 'Nie udało się zmienić długości.',
        copied: 'Skopiowane.',
        copyFailed: 'Nie udało się skopiować wpisu.',
        removeFailed: 'Nie udało się usunąć wpisu.',
        paymentFailed: 'Nie udało się zapisać płatności w Portfelu.',
        addTaskFailed: 'Nie udało się dodać zadania.',
        refreshFailed: 'Nie udało się odświeżyć planera.',
    },
    overdue: {
        days: '{n} dzień | {n} dni | {n} dni',
        one: 'jedno po terminie',
        both: 'oba po terminie',
        all: 'wszystkie po terminie',
        count: '{n} po terminie',
    },
    quality: {
        poor: 'słaby',
        average: 'przeciętny',
        good: 'dobry',
        great: 'świetny',
    },
    sleepQuality: {
        none: 'Brak oceny',
        poor: 'Słaby',
        average: 'Przeciętny',
        good: 'Dobry',
        great: 'Świetny',
    },
    event: {
        allDay: 'cały dzień',
        dayOf: 'dzień {n} z {total}',
        projectDue: 'Termin: {title}',
    },
    workout: {
        pace: 'tempo {pace} /km',
    },
    sleep: {
        qualityWord: 'jakość {quality} · {word}',
        quality: 'jakość {quality}',
        naps: '{n} drzemka | {n} drzemki | {n} drzemek',
        noBedtime: 'bez zaśnięcia',
        noWakeUp: 'bez pobudki',
        goingToBed: 'Idę spać',
    },
    report: {
        detail: 'raport dnia · {time}',
    },
    summary: {
        sleep: 'Sen',
        sleepAvg: 'średnio {duration} w 7 dniach',
        calories: 'Kalorie',
        noGoal: 'brak celu w profilu',
        move: 'Ruch',
        activeKcal: '{kcal} kcal aktywnych',
        tasks: 'Zadania',
        protein: 'Białko',
        carbs: 'Węgle',
        fat: 'Tłuszcze',
        sugar: 'Cukry',
        fibre: 'Błonnik',
    },
    maps: {
        pin: 'Pinezka z Google Maps',
    },
    firstSteps: {
        task: {
            title: 'Zadanie na dziś', action: 'Dodaj zadanie',
            what: 'Coś do zrobienia dzisiaj — wpisz w pole na górze i Enter.',
            why: 'Zadania dnia widać przy harmonogramie i w podsumowaniu; te nieodhaczone przypomną się jako zaległe.',
        },
        time: {
            title: 'Zadanie z godziną', action: 'Dodaj z godziną',
            what: 'Np. „14:30 dentysta” — godzina na początku albo na końcu.',
            why: 'Zadanie staje w swoim miejscu na harmonogramie, między posiłkami i spotkaniami.',
        },
        reminder: {
            title: 'Przypomnienie', action: 'Ustaw przypomnienie',
            what: 'Powiadomienie o zadaniu z godziną — o czasie albo chwilę przed.',
            why: 'Nie musisz pilnować godzin — telefon da znać. Domyślne przypomnienie ustawisz w Ustawieniach.',
        },
        recurring: {
            title: 'Zadanie cykliczne', action: 'Dodaj cykliczne',
            what: 'Coś, co wraca: codziennie, w dni robocze, w wybrane dni tygodnia albo co miesiąc.',
            why: 'Wpisujesz raz — po odhaczeniu samo przechodzi na następny dzień, o tej samej godzinie.',
        },
        meal: {
            title: 'Zaplanuj posiłek', action: 'Zaplanuj',
            what: 'Posiłek na później albo na jutro — z katalogu albo z produktów.',
            why: 'Na harmonogramie widać, co i kiedy zjesz; składniki zaplanowanych posiłków jednym przyciskiem trafią do Koszyka.',
        },
        workout: {
            title: 'Zaplanuj trening', action: 'Zaplanuj',
            what: 'Trening na konkretną godzinę.',
            why: 'Stoi na harmonogramie jak spotkanie; po treningu odhaczasz go kółkiem.',
        },
        sleep: {
            title: 'Wpisz sen', action: 'Wpisz sen',
            what: 'O której zasnąć i wstać — albo „Kładę się” i pobudka w Formie.',
            why: 'Noc rysuje się na harmonogramie, a podsumowanie i rytm tygodnia pokazują, ile i jak równo śpisz.',
        },
        report: {
            title: 'Wpis dnia', action: 'Napisz',
            what: 'Kilka zdań wieczorem: jak minął dzień.',
            why: 'Razem z liczbami dnia złożysz z tego eksport do AI — z kontekstem, którego liczby nie mają.',
        },
        calendar: {
            title: 'Kalendarz Google', action: 'Połącz',
            what: 'Połącz swój Google Calendar.',
            why: 'Spotkania z kalendarza staną na harmonogramie obok reszty dnia.',
        },
    },
    help: {
        planer: {
            title: 'Planer',
            text: 'Twój dzień w jednym miejscu: posiłki, sen, treningi, zadania, notatki, wydarzenia z kalendarza i płatności z Portfela — to, co już było, i to, co zaplanowane. Planer nie ma własnych wpisów: wszystko pochodzi z modułów, więc zmiana tutaj jest zmianą tam.',
            more: 'Na górze przełączasz Dzień, Tydzień i Miesiąc. Strzałki (albo ← i → na klawiaturze, przesunięcie palcem na telefonie) zmieniają dzień, a „Dziś" wraca do dzisiaj.',
        },
        add: {
            title: 'Dodawanie',
            text: 'Wpisz zadanie i Enter — trafi na ten dzień. Godzina na początku albo na końcu („14:30 dentysta”) od razu ustawia je na harmonogramie. ✨ „Wpisz zdaniem” w polu rozpozna też wydarzenie, posiłek, sen i trening — np. „jutro o 18 kino z Anią”.',
            more: '„Nowy wpis” w nagłówku (albo klawisz N) otwiera okienko z każdym rodzajem wpisu: zadanie z powtarzaniem i przypomnieniem, wydarzenie, posiłek, sen, notatka, trening, wpis dnia. Możesz też kliknąć godzinę na harmonogramie.',
        },
        timeline: {
            title: 'Harmonogram',
            text: 'Godziny dnia z wpisami w ich miejscu: długość bloku to czas trwania (sen, trening, wydarzenie). Kółko odhacza zadanie, zjedzony posiłek albo zrobiony trening. Czerwona kreska to teraz.',
            more: 'Przeciągnij wpis, żeby zmienić mu godzinę — zadania, posiłki, treningi, notatki i wydarzenia (na telefonie przytrzymaj chwilę). Kliknij wolne miejsce na harmonogramie, żeby dodać coś na tę godzinę. Zakres godzin ustawisz w Ustawieniach — harmonogram i tak się rozciąga, jeśli coś jest wcześniej lub później.',
        },
        allDay: {
            title: 'Cały dzień',
            text: 'Wydarzenia całodniowe, terminy projektów i płatności z Portfela na ten dzień. Płatność odhaczasz kółkiem — zapisze się w Portfelu jako opłacona.',
        },
        overdue: {
            title: 'Zaległe zadania',
            text: 'Nieodhaczone zadania, których godzina albo dzień już minęły — z każdego dnia, nie tylko z dzisiaj. „Przejrzyj” prowadzi do zakładki Zadania, gdzie każde przestawisz jednym kliknięciem.',
            more: 'Przy kilku zaległych jest też „Rozplanuj na dziś” — rozstawia je co pół godziny od teraz. Przy większej liczbie lepiej przejrzeć je po kolei: część pewnie nie jest już aktualna.',
        },
        noTime: {
            title: 'Bez godziny',
            text: 'To, co jest na ten dzień, ale bez konkretnej godziny: zadania („kiedyś dziś”), wydarzenia całodniowe i płatności z Portfela. Stoi nad harmonogramem, żeby nie zginęło między wpisami z godziną.',
            more: 'Przeciągnij zadanie na harmonogram, żeby dać mu godzinę — albo z harmonogramu tutaj, żeby ją zdjąć. Płatność odhaczasz kółkiem — zapisze się w Portfelu jako opłacona. Zadanie bez godziny dodasz polem na górze: wystarczy nie wpisywać godziny.',
        },
        summary: {
            title: 'Podsumowanie dnia',
            text: 'Sen, kalorie, ruch i zadania dnia. Kalorie i makra odnoszą się do celów z Ustawień → Cele i preferencje; sen i ruch — do najlepszego dnia z ostatniego tygodnia.',
        },
        report: {
            title: 'Wpis dnia',
            text: 'Kilka zdań o tym, jak minął dzień. Z wpisów i liczb dnia złożysz eksport do AI (menu ⋯ w nagłówku).',
        },
        shopping: {
            title: 'Składniki na zakupy',
            text: 'Składniki zaplanowanych posiłków z tego dnia (w Tygodniu — z całego tygodnia), zsumowane. Odznaczasz, co masz w domu, a reszta trafia do Koszyka.',
        },
        show: {
            title: 'Pokaż',
            text: 'Które rodzaje wpisów widać na harmonogramie. Liczby mówią, ile ich jest w tym widoku. Domyślny zestaw zapiszesz w Ustawieniach.',
        },
        week: {
            title: 'Tydzień',
            text: 'Siedem dni obok siebie, wpisy w swoich godzinach. Przeciągnij wpis na inny dzień albo inną godzinę; kliknij dzień, żeby go otworzyć.',
            more: 'Na telefonie tydzień to lista dni — dotknij dnia, żeby zobaczyć jego oś.',
        },
        rhythm: {
            title: 'Rytm tygodnia',
            text: 'O której zwykle wstajesz, jesz pierwszy posiłek i zasypiasz — z odchyleniem (±), które mówi, jak równy jest ten rytm.',
        },
        toSchedule: {
            title: 'Do rozplanowania',
            text: 'Luźne zadania bez dnia. Przeciągnij je na dzień albo wybierz „Na dziś” / „Jutro”. Zadanie bez dnia dodasz, zaznaczając „Jeszcze nie wiem kiedy”.',
        },
        month: {
            title: 'Miesiąc',
            text: 'Cały miesiąc w kratkach: najważniejsze wpisy dnia, czekające zadania i płatności. Kliknij dzień, żeby otworzyć go na harmonogramie.',
        },
        recurring: {
            title: 'Zadania cykliczne',
            text: 'Zadania, które wracają: codziennie, w dni robocze, w wybrane dni tygodnia albo co miesiąc. Zawsze czekają na najbliższy dzień — odhaczone zostaje w tamtym dniu, a zadanie przechodzi na następny, o tej samej godzinie.',
            more: 'Kolejne dni widać w planerze przygaszone. Regułę zmienisz w okienku zadania („Powtarzaj”), a „Nie” robi z niego zwykłe zadanie.',
        },
        done: {
            title: 'Zrobione',
            text: 'Zadania odhaczone w ostatnich dniach — możesz je odznaczyć, jeśli to pomyłka.',
        },
        settingsHours: {
            title: 'Godziny harmonogramu',
            text: 'Od której do której godziny rysuje się harmonogram dnia i tygodnia. Wpis spoza tych godzin i tak się zmieści — harmonogram się rozciąga.',
        },
        reminders: {
            title: 'Przypomnienia',
            text: 'Powiadomienie o zadaniu z godziną — o czasie albo chwilę przed. Tu wybierasz, jakie przypomnienie dostaje każde nowe zadanie z godziną; w okienku zadania zmienisz je pojedynczo.',
            more: 'Powiadomienia trzeba włączyć na każdym urządzeniu (przycisk poniżej). Na iPhonie działają w aplikacji dodanej do ekranu głównego.',
        },
        defaultVisible: {
            title: 'Widoczne rodzaje',
            text: 'Rodzaje wpisów widoczne po otwarciu planera. W widoku „Pokaż” zmienisz to na chwilę.',
        },
        calendar: {
            title: 'Kalendarz Google',
            text: 'Wydarzenia z Google Calendar trafiają na harmonogram, a wydarzenia dodane tutaj — do Google (przy włączonym eksporcie).',
        },
    },
    tour: {
        end: {
            title: 'To wszystko',
            text: 'Przewodnik wróci zawsze pod przyciskiem „Pomoc” — tam są też Pierwsze kroki. A „Co to?” przy każdej sekcji wyjaśnia ją bez przewodnika.',
        },
    },
    timelineKinds: {
        report: 'Raport',
    },
    weekSummary: {
        sleep: 'Sen · średnio',
        sleepDays: '{n} z 7 dni z wpisem snu',
        noSleep: 'brak wpisów snu w tym tygodniu',
        calories: 'Kalorie · średnio',
        move: 'Ruch · razem',
        moveBest: 'najwięcej w jednym dniu: {duration}',
    },
    rhythm: {
        wakeUp: 'Pobudka',
        firstMeal: 'Pierwszy posiłek',
        bedtime: 'Zaśnięcie',
    },
    weekNote: {
        overdue: {
            title: 'Zadania po terminie',
            text: '{n} zadanie czeka dłużej, niż miało. W tym tygodniu odhaczono {done} z {total}. | {n} zadania czekają dłużej, niż miało. W tym tygodniu odhaczono {done} z {total}. | {n} zadań czeka dłużej, niż miało. W tym tygodniu odhaczono {done} z {total}.',
        },
        sleepGaps: {
            title: 'Luki w dzienniku snu',
            text: '{n} dni bez wpisu snu — średnia z pozostałych może być myląca.',
        },
        moveFewDays: {
            title: 'Ruch skupiony w kilku dniach',
            text: 'Treningi tylko w {n} dniu tygodnia. | Treningi tylko w {n} dniach tygodnia. | Treningi tylko w {n} dniach tygodnia.',
        },
        numbers: {
            title: 'Tydzień w liczbach',
            text: '{withEntries} z 7 dni ma wpisy, ruch w {n} dniu. | {withEntries} z 7 dni ma wpisy, ruch w {n} dniach. | {withEntries} z 7 dni ma wpisy, ruch w {n} dniach.',
        },
    },
    export: {
        macros: 'B{protein}/W{carbs}/T{fat} (nas {saturated}/nien {unsaturated})/C{sugar}/Bł{fibre}/Sól{salt}',
        meal: 'Posiłek: {name} ({kcal} kcal, {macros})',
        composition: '; skład: {list}',
        workoutPlanned: 'Trening zaplanowany: {name}{extra}',
        workout: 'Trening: {name} ({parts})',
        qualityLabel: ', jakość {quality} ({label})',
        quality: ', jakość {quality}',
        wakeNote: '. Notatka: {text}',
        wake: 'Pobudka (sen {duration}{suffix}){note}',
        bedtime: 'Sen — pora spać',
        napNote: ', notatka: {text}',
        nap: 'Drzemka ({duration}{suffix}{note})',
        report: 'Raport: {text}',
        nutrition: 'Podsumowanie odżywiania: zjedzone {kcal}/{kcalGoal} kcal, białko {protein}/{proteinGoal} g, węgle {carbs}/{carbsGoal} g, tłuszcze {fat}/{fatGoal} g (nasycone {saturated} g, nienasycone {unsaturated} g), cukry {sugar}/{sugarGoal} g, błonnik {fibre} g, sól {salt} g',
        taskDone: 'zrobione',
        taskNotDone: 'niezrobione',
        taskList: ', projekt: {name}',
        task: 'Zadanie: {text} ({state}{list})',
        tasksSummary: 'Podsumowanie zadań: {done}/{total} zrobione',
        workoutsTotal: 'łącznie {duration}',
        workoutsDistance: 'dystans {distance}',
        workoutsSummary: 'Podsumowanie treningów ({n}): {parts}',
        sleepPart: 'sen {duration}{suffix}',
        napsPart: 'drzemki: {n} ({duration})',
        sleepSummary: 'Podsumowanie snu: {parts}',
        header: 'Dziennik dnia ({range}). Przeanalizuj wpisy i wskaż wzorce, zależności oraz sugestie:',
        columns: { date: 'Data', time: 'Godzina', event: 'Wydarzenie' },
        csvHead: 'data,godzina,wydarzenie',
    },
    noTime: 'Bez godziny',
    day: {
        newEntry: 'Nowy wpis',
        showKinds: 'Pokaż rodzaje wpisów',
        show: 'Pokaż',
        hiddenKinds: 'ukryte rodzaje: {n}',
        export: 'Eksport dnia do AI',
        todo: 'zadanie do zrobienia | zadania do zrobienia | zadań do zrobienia',
        events: 'wydarzenie | wydarzenia | wydarzeń',
        freeToday: 'niezaplanowane do końca dnia',
        free: 'niezaplanowane',
        schedule: 'HARMONOGRAM',
        tasksProgress: 'zadania {done} / {total}',
        scrollToNow: 'Przewiń do teraz',
        now: 'Teraz',
        tomorrowOn: 'Jutro, {date}',
        nothingPlanned: 'nic zaplanowanego',
        emptyAdd: 'Nic zaplanowanego — dodaj',
        emptyAddColon: 'Nic zaplanowanego — dodaj:',
    },
    week: {
        number: 'tydzień {n}',
        export: 'Eksport tygodnia do AI',
        heading: 'TYDZIEŃ',
        more: '+ {n} więcej',
        dragHint: 'Przeciągnij zadanie na dzień i godzinę w tygodniu.',
        summary: 'PODSUMOWANIE TYGODNIA',
        rhythm: 'RYTM',
        shopping: 'ZAKUPY',
        ingredients: 'Składniki {n} posiłku z tygodnia | Składniki {n} posiłków z tygodnia | Składniki {n} posiłków z tygodnia',
    },
    task: {
        tick: 'Odhacz zadanie',
        untick: 'Odznacz zadanie',
    },
    tasks: {
        toSchedule: 'DO ROZPLANOWANIA · {n}',
        addWithoutDay: 'Dodaj bez dnia',
        allHaveDay: 'Wszystkie zadania mają dzień.',
    },
    tasksPage: {
        title: 'Zadania',
        subtitle: '{overdue} po terminie · {unscheduled} do rozplanowania',
        today: 'Dziś',
        tomorrow: 'Jutro',
        oldestWaiting: 'najstarsze czeka {n} dzień | najstarsze czeka {n} dni | najstarsze czeka {n} dni',
        quickPlaceholder: 'Zadanie na dziś — np. „17:00 odebrać paczkę”',
        overdue: 'ZALEGŁE · {n}',
        noOverdue: 'Nic po terminie. 👏',
        everyHasDay: 'Każde zadanie ma dzień.',
        dragHint: 'Przeciągnij na dzień obok albo wybierz „Na dziś” / „Jutro”.',
        recurring: 'CYKLICZNE · {n}',
        addRecurring: 'Dodaj cykliczne',
        noRecurring: 'Brak — np. „Leki” codziennie o 8:00 albo „Śmieci” w czwartki.',
        until: 'do {date}',
        next: 'następne: {label}',
        next7: 'NAJBLIŻSZE 7 DNI',
        taskCount: '{n} zadanie | {n} zadania | {n} zadań',
        done: 'ZROBIONE · 7 DNI',
        noneDone: 'Jeszcze nic w tym tygodniu.',
    },
    month: {
        heading: 'MIESIĄC',
        weekdays: { mon: 'pon', tue: 'wt', wed: 'śr', thu: 'czw', fri: 'pt', sat: 'sob', sun: 'nd' },
        openTasks: 'Czekające zadania: {n}',
        noTimeTask: 'Bez godziny: {text}',
        dragHint: 'Przeciągnij wpis na inny dzień, żeby go przenieść — godzina zostaje ta sama.',
    },
    settings: {
        title: 'Ustawienia planera',
        hours: 'GODZINY HARMONOGRAMU',
        from: 'od',
        to: 'do',
        reminders: 'PRZYPOMNIENIA',
        reminderDefault: 'Nowe zadanie z godziną dostaje przypomnienie:',
        pushNoServer: 'Serwer nie ma jeszcze włączonych powiadomień push.',
        pushHomeScreen: 'Na iPhonie powiadomienia działają w aplikacji dodanej do ekranu głównego (Udostępnij → Do ekranu początkowego).',
        pushUnsupported: 'Ta przeglądarka nie obsługuje powiadomień push.',
        pushDisable: 'Wyłącz na tym urządzeniu',
        pushEnable: 'Włącz na tym urządzeniu',
        pushHere: 'Włączone tutaj',
        pushNotHere: 'Wyłączone tutaj',
        pushOn: 'Powiadomienia włączone na tym urządzeniu.',
        pushOff: 'Powiadomienia wyłączone na tym urządzeniu.',
        pushDenied: 'Przeglądarka blokuje powiadomienia — zezwól na nie w ustawieniach strony.',
        pushFailed: 'Nie udało się włączyć powiadomień.',
        moduleReminders: 'Przypomnienia z modułów (od 9:00):',
        moduleReminderHint: 'Ludzie: urodziny i ważne daty, dawno bez kontaktu. Zwierzęta i Sprzęty: obsługi, gwarancje, urodziny zwierzaka. Nawyki: o godzinie ustawionej przy nawyku, jeśli jeszcze nie jest odhaczony. Leki: o godzinie dawki i pół godziny później, gdy nieodhaczona; gdy zapas starcza na mniej niż tydzień.',
        moduleReminderModules: {
            people: 'Ludzie',
            pets: 'Zwierzęta',
            devices: 'Sprzęty',
            habits: 'Nawyki',
            medications: 'Leki',
        },
        visible: 'WIDOCZNE PO OTWARCIU',
        calendar: 'KALENDARZ GOOGLE',
        calendarLink: 'Połączenie i synchronizacja',
        firstSteps: 'PIERWSZE KROKI',
        firstStepsText: 'Zadania, przy których poznasz planer — każde z wyjaśnieniem, czym jest i po co.',
        firstStepsShow: 'Pokaż Pierwsze kroki',
        firstStepsProgress: '{done} z {total}',
        shortcutsTitle: 'SKRÓTY KLAWISZOWE',
        shortcuts: {
            prevNext: 'poprzedni / następny dzień (tydzień, miesiąc)',
            today: 'dziś',
            newEntry: 'nowy wpis',
            quickAdd: 'pole szybkiego dodawania',
            save: 'zapis w okienku wpisu',
        },
    },
    allDay: {
        heading: 'CAŁY DZIEŃ',
        paid: 'Opłacone',
        markPaid: 'Oznacz jako opłacone: {title}',
        instalmentInWallet: 'Ratę odhaczysz w Portfelu',
    },
    dateNav: {
        prevDay: 'Poprzedni dzień',
        nextDay: 'Następny dzień',
        prevWeek: 'Poprzedni tydzień',
        nextWeek: 'Następny tydzień',
        prevMonth: 'Poprzedni miesiąc',
        nextMonth: 'Następny miesiąc',
        today: 'Dziś',
        todayKey: 'Dziś (T)',
        pickWith: '{label} — wybierz dzień',
        pickFromCalendar: 'Wybierz dzień z kalendarza',
        thisWeek: 'Ten tydzień',
        thisMonth: 'Ten miesiąc',
    },
    daySide: {
        missing: {
            sleep: { text: 'Brak snu', action: 'Wpisz' },
            calories: { text: 'Brak posiłków', action: 'Dodaj' },
            move: { text: 'Bez ruchu', action: 'Dodaj trening' },
        },
        summary: 'PODSUMOWANIE',
        ofGoal: '{percent}% z {goal} g',
        noGoal: 'bez celu',
        sleep7: 'SEN · 7 DNI',
        noSleepWeek: 'Brak snu w tym tygodniu',
        logNight: 'Wpisz noc',
        noEntry: '{day} — brak wpisu',
        avgPerNight: 'Średnio {duration} na noc',
        report: 'WPIS DNIA',
        reportPrompt: 'Jak minął dzień? Napisz kilka zdań',
        ingredients: 'Składniki {n} posiłku do Koszyka | Składniki {n} posiłków do Koszyka | Składniki {n} posiłków do Koszyka',
    },
    entry: {
        markPlanned: 'Oznacz jako zaplanowany',
        markDone: 'Oznacz jako zrobiony',
        markEaten: 'Oznacz jako zjedzony',
        plan: 'plan',
        overdue: 'po terminie',
        actions: 'Akcje: {title}',
    },
    menu: {
        untick: 'Odznacz',
        taskDone: 'Zrobione',
        backToPlanned: 'Cofnij na zaplanowany',
        workoutDone: 'Zrobiony',
        eaten: 'Zjedzony',
        editSeries: 'Edytuj całą serię',
        openProject: 'Otwórz projekt',
        openPerson: 'Otwórz osobę',
        openPet: 'Otwórz zwierzę',
        openDevice: 'Otwórz sprzęt',
        edit: 'Edytuj',
        tomorrow: 'Przenieś na jutro',
        duplicate: 'Duplikuj',
        remove: 'Usuń',
        removeTitle: 'Usunąć „{title}”?',
        thisEntry: 'ten wpis',
        removeMessage: 'Wpis zniknie z planera i ze swojego modułu. Tego nie da się cofnąć.',
    },
    filtersPanel: {
        heading: 'POKAŻ',
        hidden: '{n} ukryte',
        all: 'Wszystkie',
    },
    overdueBar: {
        show: 'Pokaż pasek zaległych',
        oldest: ' · najstarsze: {text} ({time})',
        hide: 'Ukryj do jutra',
        spreadTitle: 'Rozstaw zaległe na dziś co pół godziny od teraz',
        spread: 'Rozplanuj na dziś',
        review: 'Przejrzyj',
    },
    quickAdd: {
        placeholder: 'Dodaj zadanie, np. „14:30 dentysta”',
        newTask: 'Nowe zadanie',
        sentenceTitle: 'Wpisz zdaniem — rozpozna też wydarzenie, posiłek, sen i trening',
        sentenceLabel: 'Wpisz zdaniem: rozpozna wydarzenie, posiłek, sen i trening',
        sentence: 'Wpisz zdaniem',
        add: 'Dodaj',
        preview: 'Zadanie {text} o {time} — na harmonogramie',
        quoted: '„{text}”',
    },
    shopping: {
        title: 'Składniki na zakupy',
        noIngredients: 'Te posiłki nie mają składników z produktów — nie ma czego dodać.',
        failed: 'Nie udało się zebrać składników.',
        added: 'Składniki są w Koszyku.',
    },
    sidebar: {
        overdue: 'zaległe zadania',
        todo: 'zadania do zrobienia',
        withEntries: 'dzień z wpisami',
    },
    taskRow: {
        today: 'dziś',
        overdueFor: 'po terminie {time}',
        reschedule: 'Przestaw: {text}',
        actions: {
            now: 'Teraz',
            today: 'Na dziś',
            tomorrow: 'Jutro',
            untime: 'Bez godziny',
            unplan: 'Do rozplanowania',
        },
    },
    grid: {
        resize: 'Przeciągnij, żeby zmienić długość',
        until: 'do {time}',
    },
    agenda: {
        nothingPlanned: 'Nic zaplanowanego.',
        noTime: 'bez godziny',
        tick: 'Odhacz',
    },
    wholeDay: {
        heading: 'BEZ GODZINY',
        dropHere: 'Upuść, żeby zdjąć godzinę',
        dropHereSentence: 'Upuść, żeby zdjąć godzinę.',
    },
    oldDay: {
        sources: {
            mealEntries: 'posiłki',
            workouts: 'treningi',
            sleep: 'sen',
            dayReports: 'wpisy dnia',
            meals: 'zapisane posiłki',
            products: 'produkty',
            checklists: 'listy zadań',
            workoutTypes: 'rodzaje treningów',
            profile: 'profil',
            events: 'wydarzenia',
            activities: 'czynności',
        },
        overdue: '{n} zadanie po terminie. | {n} zadania po terminie. | {n} zadań po terminie.',
        oldestSince: 'Najstarsze czeka od {time}.',
        rescheduleFailed: 'Nie udało się przestawić terminu.',
        spreadTitle: 'Rozstaw zaległe co pół godziny od teraz',
        spread: 'Rozplanuj',
        partialFail: 'Nie udało się pobrać: {list}. Reszta dnia działa normalnie.',
        loading: 'Ładuję dzień…',
        loadFailed: 'Nie udało się pobrać danych dnia.',
        retry: 'Spróbuj ponownie',
    },
    oldWeek: {
        viewingCurrent: 'Oglądasz bieżący tydzień',
        backToCurrent: 'Wróć na bieżący tydzień',
        partialFail: 'Nie udało się pobrać: {list}. Reszta tygodnia działa normalnie.',
        loading: 'Ładuję tydzień…',
        loadFailed: 'Nie udało się pobrać danych tygodnia.',
    },
    header: {
        today: 'Dzisiaj',
        viewingToday: 'Oglądasz dzisiejszy dzień',
        backToToday: 'Wróć na dzisiaj',
        calendar: 'Kalendarz',
        export: 'Eksport dziennika do AI',
    },
    oldSidebar: {
        today: 'Dzisiaj',
        week: 'Tydzień',
        month: 'Miesiąc',
        summaries: 'Podsumowania',
        tagline: 'PLANER DNIA',
        soon: '{label} — wkrótce',
        hide: 'Ukryj: {label}',
        show: 'Pokaż: {label}',
    },
    oldSummary: {
        heading: 'PODSUMOWANIE DNIA',
        overdue: 'PO TERMINIE · {n}',
        openTask: 'Otwórz zadanie',
        editTask: 'Edytuj zadanie',
        nothingNoTime: 'Nic nie czeka bez godziny.',
        addTask: 'Dodaj zadanie',
        macros: 'MAKRA',
        meals: '{n} posiłek | {n} posiłki | {n} posiłków',
        sleep7: 'OSTATNIE 7 DNI · SEN',
        savedToday: 'Zapisane tego dnia',
        editReport: 'Edytuj raport',
        howWasDay: 'Jak minął dzień?',
        reportHint: 'Zapisz raport dnia — trafi na oś o swojej godzinie i zostanie w podsumowaniu.',
        saveReport: 'Zapisz raport dnia',
    },
    oldTimeline: {
        allHidden: 'Wszystkie wpisy tego dnia są ukryte w sekcji „Pokaż".',
        emptyTitle: 'Ten dzień jest jeszcze pusty',
        emptyText: 'Powiedz, co masz w planach, albo dodaj wpis ręcznie — pojawi się tutaj o swojej godzinie.',
        say: 'Powiedz, co dodać',
        addManually: 'Dodaj ręcznie',
    },
    exportDialog: {
        title: 'Eksport do AI',
        subtitle: 'Dziennik jako tabela do wklejenia w rozmowę z modelem.',
        close: 'Zamknij',
        from: 'Od dnia',
        to: 'Do dnia',
        format: 'Format',
        text: 'Tekst',
        reversed: 'Dzień początkowy jest późniejszy niż końcowy — zamień je miejscami.',
        tooLong: 'Eksport obejmuje najwyżej {n} dni — skróć zakres.',
        output: 'Wyeksportowany dziennik',
        empty: 'W tym zakresie nie ma żadnych wpisów.',
        rows: '{n} wiersz | {n} wiersze | {n} wierszy',
        chars: '{n} znak | {n} znaki | {n} znaków',
        copied: 'Skopiowane',
        copy: 'Kopiuj',
    },
    sleepWeek: {
        avg: 'Średnio {duration}',
        none: 'Brak wpisów snu w tym tygodniu',
    },
    template: {
        nameRequired: 'Nazwa jest wymagana',
        edit: 'Edytuj szablon',
        new: 'Nowy szablon',
        name: 'Nazwa szablonu',
        namePlaceholder: 'np. Wyjazd',
        items: 'POZYCJE',
        drag: 'Przeciągnij, aby zmienić kolejność',
        item: 'Pozycja {n}',
        removeItem: 'Usuń pozycję {n}',
        addItem: 'Dodaj pozycję',
        hint: 'Enter dodaje kolejną pozycję, uchwyt po lewej zmienia kolejność. Puste wiersze pomijamy.',
        cancel: 'Anuluj',
        saving: 'Zapisuję…',
        save: 'Zapisz',
        removeTitle: 'Usunąć szablon?',
        removeMessage: 'Listy utworzone z tego szablonu zostają. Samego szablonu nie da się odzyskać.',
    },
    timelineEntry: {
        saturated: 'Nasycone',
        salt: 'Sól',
        nowTitle: 'Przestaw termin na teraz',
        now: 'Zrób teraz',
        clearTitle: 'Zadanie zostaje na dziś, ale bez godziny',
        clear: 'Zdejmij termin',
        quote: '„{text}"',
        syncPending: 'Zmiana czeka na wysłanie do Google Calendar',
        synced: 'Zsynchronizowane z Google Calendar',
        backToPlanned: 'Cofnij do zaplanowanego',
        inPlan: 'w planie',
        eaten: 'zjedzone',
        markDone: 'Oznacz jako wykonany',
        done: 'wykonany',
        complete: 'Uzupełnij wpis',
        navigate: 'Nawiguj w Google Maps',
        edit: 'Edytuj wpis',
        ingredients: 'SKŁAD',
        noIngredients: 'Ten wpis nie ma zapisanego składu.',
    },
    weekColumn: {
        openDay: 'Otwórz {weekday} {day} w widoku dnia',
        navigate: 'Nawiguj w Google Maps: {place}',
    },
    weekGrid: {
        sleep: 'SEN',
        kcal: 'KCAL',
        move: 'RUCH',
        planKcal: 'plan ~{n}',
        planMoves: 'plan {n}',
    },
    weekSummaryPanel: {
        spread: '± to rozrzut godzin w tym tygodniu.',
        toSchedule: 'DO ROZPLANOWANIA',
        assign: 'Przypisz do dnia',
        openToAssign: 'Otwórz zadanie, żeby wskazać dzień.',
        allAssigned: 'Wszystkie zadania mają swój dzień.',
    },
    weekUnscheduled: {
        ticked: 'odhaczone',
        more: '{n} zadanie bez godziny — przewiń pasek | {n} zadania bez godziny — przewiń pasek | {n} zadań bez godziny — przewiń pasek',
    },
};
